/**
 * 音频流处理
 */

class AudioStream {
  private streams: MediaStream[] | null;
  private mergedStream: MediaStream | null;
  constructor() {
    this.streams = null;
    this.mergedStream = null;
  }

  /**
   * 将所有的音频流合并成一个音频流
   * @param streams
   * @returns
   */
  public merge(streams: MediaStream[]) {
    this.streams = streams.filter((stream) => !!stream);
    if (streams.length === 1) {
      return streams[0];
    }
    // 合并音频流
    const audioCtx = new AudioContext();
    const destination = audioCtx.createMediaStreamDestination();

    // const gainNode = audioCtx.createGain();
    // gainNode.gain.value = 0.7;

    streams.forEach((stream) => {
      if (stream) {
        const soundSource = audioCtx.createMediaStreamSource(stream);
        // soundSource.connect(gainNode).connect(destination);
        soundSource.connect(destination);
      }
    });

    this.mergedStream = destination.stream;

    return destination.stream;
  }

  /**
   * 关闭所有的音频流并释放资源
   */
  public dispose() {
    this.streams?.forEach((stream) => {
      this._closeStream(stream);
    });
    this.streams = [];
    if (this.mergedStream) {
      this._closeStream(this.mergedStream);
      this.mergedStream = null;
    }
  }

  private _closeStream(stream: MediaStream) {
    if (!stream) return;
    stream.getTracks().forEach((track) => {
      track.stop();
    });
  }
}

export default AudioStream;
